import { produce } from 'immer'
import { MccGroupListResponse } from 'src/models/mccGroup.models'
import {
  GET_MCC_GROUPS_SUCCESS,
  GetMccGroupsSuccessAction,
} from 'src/redux/actions/data/mccGroups.actions'

export interface MccGroupsState {
  listResponses: Record<string, MccGroupListResponse>
  order: string[]
}

export const initialState: MccGroupsState = {
  listResponses: {},
  order: [],
}

export type Actions = GetMccGroupsSuccessAction

const MccGroupsReducer = (
  state: MccGroupsState = initialState,
  action: Actions,
): MccGroupsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_MCC_GROUPS_SUCCESS: {
        draft.listResponses = action.payload.mccGroups.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          {},
        )
        draft.order = action.payload.mccGroups.map((group) => group.id)
        return draft
      }
    }
  })
}

export default MccGroupsReducer
